module.exports = __webpack_public_path__ + "static/img/L05.760e7a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/L05.jpg
// module id = muqH
// module chunks = 9